// react core
import { useContext } from "react";

// material design
import Box from "@mui/material/Box";

// fonts and colors
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera as iconEmptyFrame } from "@fortawesome/pro-duotone-svg-icons";

// entzy config and context
import configEntzy from "components/config/ConfigEntzy";
import { MainContext } from "components/main/MainContext";
import { EventContext } from "components/event/EventContext";
import { ActionLoader } from "components/utils/common/CommonLoaders";

// entzy hooks
import { useMediaImage } from "hooks/media/mediaImage";

function ActionLaunchpadFramePreview(props) {
  const user = props.user;
  const previewSize = props.size ? props.size : "md";
  const mainContext = useContext(MainContext);
  const eventContext = useContext(EventContext);

  // capture current frame details;
  const frameId = props.frame.id;
  const frameData = eventContext.state.event.data.ImageFrames
    ? eventContext.state.event.data.ImageFrames.filter(
        (obj) => obj.id === frameId,
      )
    : [];
  const framePath = frameData.length
    ? frameData[0].path
    : configEntzy.EMPTY_STRING_SHORTSET;

  // load page images
  const mediaImage = useMediaImage(
    eventContext.state.event.hydrated
      ? {
          user: user,
          context: mainContext,
          image: {
            id:
              "event:frames:" +
              frameId +
              ":" +
              eventContext.state.event.data.EventId,
            key: framePath,
          },
        }
      : null,
  );

  return (
    <Box className="box-default">
      {!mediaImage ? (
        <ActionLoader size={previewSize} />
      ) : (
        <Box className="box-default">
          <Box
            className="box-default"
            sx={{
              p: configEntzy.APP_SPACING_XS,
              borderRadius: configEntzy.BORDER_SIZE_XL,
            }}
          >
            <Box className="box-default relative">
              <Box
                className="box-default"
                sx={{
                  "&::before": {
                    content: `''`,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundImage:
                      mediaImage.hydrated &&
                      mediaImage.images.lg &&
                      framePath !== configEntzy.EMPTY_STRING_SHORTSET
                        ? "url(" + mediaImage.images.lg.data + ")"
                        : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "repeat-y",
                    // filter:
                    //   mediaImage.hydrated && mediaImage.images.lg
                    //     ? "blur(1px)"
                    //     : "none",
                    borderRadius: configEntzy.BORDER_SIZE_XL,
                    borderColor:
                      mediaImage.hydrated && mediaImage.images.lg
                        ? "black"
                        : "#555",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    opacity: 1,
                    zIndex: -1,
                  },
                }}
              >
                <Box
                  className="box-default"
                  sx={{
                    width:
                      previewSize === "xs"
                        ? configEntzy.AVATAR_SIZE_SM
                        : previewSize === "sm"
                        ? configEntzy.AVATAR_SIZE_MD
                        : previewSize === "md"
                        ? configEntzy.AVATAR_SIZE_LG
                        : previewSize === "lg"
                        ? configEntzy.AVATAR_SIZE_XL
                        : configEntzy.AVATAR_SIZE_XXL,
                    height:
                      previewSize === "xs"
                        ? configEntzy.AVATAR_SIZE_SM
                        : previewSize === "sm"
                        ? configEntzy.AVATAR_SIZE_MD
                        : previewSize === "md"
                        ? configEntzy.AVATAR_SIZE_LG
                        : previewSize === "lg"
                        ? configEntzy.AVATAR_SIZE_XL
                        : configEntzy.AVATAR_SIZE_XXL,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {mediaImage.hydrated &&
                  mediaImage.images.lg &&
                  framePath !== configEntzy.EMPTY_STRING_SHORTSET ? (
                    <></>
                  ) : (
                    <FontAwesomeIcon
                      icon={iconEmptyFrame}
                      transform={
                        previewSize === "xs"
                          ? "grow-10"
                          : previewSize === "sm"
                          ? "grow-15"
                          : previewSize === "md"
                          ? "grow-20"
                          : previewSize === "lg"
                          ? "grow-25"
                          : "grow-30"
                      }
                      color="gray"
                    />
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default ActionLaunchpadFramePreview;
